import { createMiddleware } from '@shared/redux';
import {
    EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED,
    getSelectedGroup,
} from '@domain/segments';
import {
    CHANGE_DASHBOARD_FILTER,
} from '@domain/dashboard/dashboard-filters/dashboard-filters.state';
import {
    getTagGroupSegmentedReportParams,
    shouldFetchReport,
} from './tag-groups-segmented.utils';
import {
    clearSegmentedTagGroup,
    getTagGroupSegmentedReport,
    HANDLE_GET_TAG_GROUP_SEGMENTED_REPORT,
} from './tag-groups-segmented.state';

export const tagGroupSegmentedMiddleware = createMiddleware({
    [EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED]: (state, action) => [
        clearSegmentedTagGroup({ groupSlug: action.requestAction.payload.segment.slug }),
    ],
    [CHANGE_DASHBOARD_FILTER]: state => [
        clearSegmentedTagGroup(
            { groupSlug: state.segments.currentSegments.selectedGroup.slug },
        ),
    ],
    [HANDLE_GET_TAG_GROUP_SEGMENTED_REPORT]: (state) => {
        if (!shouldFetchReport(state)) {
            return [];
        }

        const { groups, ...baseParams } = getTagGroupSegmentedReportParams(state);
        const actions = groups.map(group => getTagGroupSegmentedReport(
            {
                ...baseParams,
                tag: group.tag,
                groupSlug: group.groupSlug,
                campaigns: group.campaigns,
            },
        ));

        const selectedGroup = getSelectedGroup(state);
        return [
            clearSegmentedTagGroup({ groupSlug: selectedGroup.slug }),
            ...actions,
        ];
    },
});
